import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiVideo, FiUsers, FiCalendar, FiCast, FiCode } from 'react-icons/fi';
import { TbQrcode } from 'react-icons/tb';
import { getLocaleFromPathname } from '../config/localeRoutes';
import './Solutions.css';

const SOLUTION_CARDS = [
  {
    key: 'assistanceVideo',
    url: 'https://assistance-video.fr',
    internalPath: '/solutions/assistance-video-client/',
    icon: <FiVideo aria-hidden />,
  },
  {
    key: 'assistanceQR',
    url: 'https://assistance.leagora.io',
    internalPath: '/solutions/assistance-qr-code/',
    icon: <TbQrcode aria-hidden />,
  },
  {
    key: 'meeting',
    url: 'https://meeting.leagora.io',
    internalPath: '/solutions/visioconference-professionnelle/',
    icon: <FiUsers aria-hidden />,
  },
  {
    key: 'mesRdv',
    url: 'https://mes-rdv.fr',
    internalPath: '/solutions/rendez-vous-video/',
    icon: <FiCalendar aria-hidden />,
  },
  {
    key: 'live',
    url: 'https://live.gniarkgniark.fr',
    internalPath: '/solutions/streaming-live/',
    icon: <FiCast aria-hidden />,
  },
  {
    key: 'customVideo',
    url: null,
    internalPath: '/solutions/video-sur-mesure-webrtc/',
    icon: <FiCode aria-hidden />,
    internalOnly: true,
  },
];

function Solutions() {
  const { t } = useTranslation();
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname);

  return (
    <section className="solutions" id="solutions">
      <div className="solutions-container">
        <div className="solutions-header">
          <h2 className="solutions-title">{t('solutions.title')}</h2>
          <p className="section-quick-answer">{t('solutions.quickAnswer')}</p>
          <p className="solutions-subtitle">{t('solutions.subtitle')}</p>
          {locale === 'fr' ? (
            <p className="solutions-internal-index">
              <Link to="/solutions/">{t('solutions.viewAllSolutions')}</Link>
            </p>
          ) : null}
        </div>

        <div className="solutions-grid">
          {SOLUTION_CARDS.map((solution) => (
            <article key={solution.key} className="solution-card-wrapper">
              {solution.internalOnly ? (
                <Link to={solution.internalPath} className="solution-card">
                  <div className="solution-icon">{solution.icon}</div>
                  <h3 className="solution-title">{t(`solutions.${solution.key}.title`)}</h3>
                  <p className="solution-description">{t(`solutions.${solution.key}.description`)}</p>
                  <div className="solution-url">{t('solutions.learnOnLeagora')}</div>
                  <div className="solution-arrow">→</div>
                </Link>
              ) : (
                <>
                  <a
                    href={solution.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="solution-card"
                  >
                    <div className="solution-icon">{solution.icon}</div>
                    <h3 className="solution-title">{t(`solutions.${solution.key}.title`)}</h3>
                    <p className="solution-description">{t(`solutions.${solution.key}.description`)}</p>
                    <div className="solution-url">{solution.url.replace('https://', '')}</div>
                    <div className="solution-arrow">→</div>
                  </a>
                  {locale === 'fr' ? (
                    <Link to={solution.internalPath} className="solution-internal-link">
                      {t('solutions.learnOnLeagora')}
                    </Link>
                  ) : null}
                </>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Solutions;
